import RelationshipEmailInfoComponent from './RelationshipEmailInfoContainer';

export default RelationshipEmailInfoComponent;